import { BehaviorSubject } from 'rxjs';
import { addError, clearError } from './Error';
import { RpmRun } from './RunTotal';
import { getLatestRpmRun } from '../Api/RpmRun/rpmRunApi';

const rpmRunSubject = new BehaviorSubject<RpmRun | null>(null);
const rpmRunLoadingSubject = new BehaviorSubject<boolean>(false);

export const getRpmRunSubject = (): BehaviorSubject<RpmRun | null> => rpmRunSubject;
export const getRpmRunLoadingSubject = (): BehaviorSubject<boolean> => rpmRunLoadingSubject;

export const fetchRPMRun = async () => {
  rpmRunLoadingSubject.next(true);

  const { data, error } = await getLatestRpmRun();
  if (data) {
    clearError('rpm-run');
    rpmRunSubject.next(data);
    return data;
  }
  if (error) addError('rpm-run', error.message);

  rpmRunLoadingSubject.next(false);
};
